/**
 * BusinessLeversModule — thin alias over CausalityModule for Business tab.
 * Keeps the richer canvas experience without duplicating implementation.
 */

import { CausalityModule } from '../causality/CausalityModule.js';

export class BusinessLeversModule extends CausalityModule {
  constructor() {
    super();
  }
}

export default BusinessLeversModule;
